<template>
  <div class="records" style="margin-top: -10px">
    <!--  heading block -->
    <GlobalHeader
      :title="'Record Service for ' + lists.service_name"
      @redirectPage="redirectPage"
    ></GlobalHeader>
    <!-- Validation for records -->

    <b-row class="mt-2 px-3">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <b-alert
          class="alert-transparent alert-danger"
          :show="error_show && this.errors.any()"
        >
          <button type="button" @click="error_show = !error_show" class="close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div
            v-for="item in errors.items"
            :key="item.id"
            v-if="item.scope == 'service_form'"
          >
            <p class="fw-semi-bold">{{ item.msg }}</p>
          </div>
        </b-alert>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('service_form')"
      id="service_form"
      data-vv-scope="service_form"
      style="margin-left: -5px; margin-right: -5px"
    >
      <div
        class="sales-bg pt-30p pb-4 mb-2 border-bottom"
        style="background: #f7f7f7"
      >
        <!--  amcservice name -->
        <b-row>
          <b-col xl="10" lg="10" md="10" sm="10" xs="10">
            <form class="form-inline">
              <label class="my-1 mr-5" label-for="name">
                Customer Name
                <span class="text-danger pl-1">*</span>
              </label>
              <b-form-input
                class="customer_search"
                type="text"
                v-model.trim="field.cus_id"
                size="sm"
                disabled
                data-vv-name="customer"
                name="cus_id"
                v-validate="'required'"
              />
            </form>
          </b-col>
        </b-row>
      </div>
      <b-row style="max-width: 1000px" class="mt-3">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            label="Available Services"
            label-for="available services"
            breakpoint="md"
            class="mb-3"
          >
            <b-form-input
              class="form-control"
              type="text"
              size="sm"
              :disabled="true"
              :value="field.pdt_qty"
            />
          </b-form-group>
        </b-col>
        <b-col cols="5" class="pl-1">
          <b-form-group
            label="Used Services"
            label-for="used-services"
            breakpoint="md"
            class="mb-3"
            label-class="required"
          >
            <b-form-input
              type="text"
              size="sm"
              name="amc_pdt_qty"
              v-validate="
                'required|between:0,' +
                field.pdt_qty +
                '|excluded:0|max_value:' +
                field.pdt_qty +
                '|decimal:0'
              "
              v-model.trim="field.amc_pdt_qty"
              data-vv-name="used product quantity"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row style="max-width: 1000px">
        <b-col cols="12" lg="5" md="6" sm="8">
          <!-- The date of payment -->
          <b-form-group
            label-class="required"
            label="Service On"
            label-for="Service On"
            class="mb-3"
          >
            <DatePicker
              :format="$AppDetails.organization.date_format"
              v-validate="'required|date_format:yyyy-MM-dd'"
              input-name="service_date"
              data-vv-name="service date"
              lang="en"
              input-class="form-control"
              @change="selectDate"
              style="width: 100% !important"
              name="service date"
              v-model.trim="field.service_date"
              :not-after="field.amc_end_date"
              :not-before="field.amc_start_date"
              placeholder=" "
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row style="max-width: 1000px" class="mt-4">
        <b-col xl="10" lg="10" md="12" sm="12" xs="12">
          <label for="datetimepicker">Service Description</label>
          <b-form-textarea
            v-model="field.service_desc"
            name="service_desc"
            :rows="4"
            id="service_desc"
            placeholder="Description"
            data-vv-name="description"
            v-validate="'max:255'"
          />
        </b-col>
      </b-row>

      <div>
        <!-- footer block -->
        <div class="footer">
          <div :class="{ 'form-action': true, 'text-left': true }">
            <b-button type="submit" variant="primary" class="btn-rounded mr-3"
              >Save</b-button
            >
          </div>
        </div>
      </div>
    </b-form>

    <b-modal
      :no-close-on-backdrop="true"
      id="nextservice"
      :title="'Next service Date'"
      ref="next_service_date"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Save"
      size="sm"
      :ok-disabled="submitted&&duplicatecode==false"
      :ok-title-html="submitted == true &&duplicatecode==false ? loaderIcon + 'Save' : 'Save'"
      @ok.prevent="onSubmit('next_service')"
    >
      <b-form
        @submit.prevent="onSubmit('next_service')"
        data-vv-scope="next_service"
      >
        <b-row>
          <b-col>
            <b-form-group>
              <DatePicker
                placeholder=" "
                :format="$AppDetails.organization.date_format"
                v-validate="'date_format:yyyy-MM-dd'"
                input-name="Next service"
                lang="en"
                input-class="form-control"
                @change="checkdate($event, 'next_service_date')"
                style="width: 95% !important"
                name="Next service"
                v-model.trim="field.next_service_date"
                :not-after="field.amc_end_date"
                :not-before="field.service_date"
              >
                <i class="fa fa-calendar text-dark" slot="calendar-icon" />
              </DatePicker>
              <span
                class="text-danger"
                v-if="
                  modal_validation && errors.has('next_service.Next service')
                "
                >The service date must be between
                {{ getDateFormat(field.service_date) }} and
                {{ getDateFormat(field.amc_end_date) }}</span
              >
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<script scoped>
// import all the components, files and funciton
import DatePicker from "vue2-datepicker"; // vue datepicker
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import vSelect from "vue-select";
import $ from "jquery"; // for using jquery function
import { mapState } from "vuex";
export default {
  props: ["lists","duplicatecode"],
  mixins: [notificationMixin, formatDate],
  name: "Records", // page name
  components: {
    DatePicker, //datepicker
    vSelect,
  },
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: {
        cus_id: "",
        service_date: "",
        amc_itm_id: "",
        amc_pdt_qty: "",
        service_desc: "",
        next_service_date: "",
        total_pdt_qty: "",
        total_used_qty: "",
      },
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false, //submitted

      error_show: false, // to show the error message
      modal_validation: false,
    };
  },
  methods: {
    redirectPage() {
      this.$router.push({
        name: "AmcContractView",
        params: { id: this.$route.query.amc_contract_id },
      });
    },
    checkdate(val, field) {
      this.field[field] =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    //  service form details
    updateService() {
      this.field = this.lists;
    },

    //validation during onsubmit
    onSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var remaining_service =
            parseInt(this.field.total_pdt_qty) -
            parseInt(this.field.total_used_qty) -
            parseInt(this.field.amc_pdt_qty);
          if (scope == "service_form" && remaining_service > 0) {
            this.$refs.next_service_date.show();
            //   //  send the json data
            this.error_show = false;
            //  send the json data
          } else {
            this.submitted = true;
            this.modal_validation = false;
            this.$emit("onSubmit", this.field);
          }
        } else {
          this.submitted = false;
          if (scope == "service_form") {
            // Scroll to error message show

            this.error_show = true; // show validation message
          } else {
            this.modal_validation = true;
          }
        }
      });

      return false;
    },
  },
  created() {
    if (!this.lists) {
      this.$router.push({
        name: "AmcContractView",
        params: { id: this.$route.query.amc_contract_id },
      });
    }
    this.initializationMessengerCode();
    this.updateService();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
    computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: state => state.amccontract.Viewlist,
      code: state => state.amccontract.code,
      status_message: (state) => state.amccontract.status_message,
      status_type: (state) => state.amccontract.status_type,
      status_code: state => state.amccontract.status_code,
    })
  }

};
</script>
<style scoped>
.customer_search {
  width: 638px !important;
}
@media (min-width: 10px) and (max-width: 1169px) {
  .customer_search {
    width: 350px !important;
  }
}
</style>